import { useSearchParams } from 'react-router-dom';

import { QUERYPARAMS } from 'config/environments/shared';

export const useDrawer = (drawerName: string) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const toogleRedirectTo = (path: string) => {
    setSearchParams({});
    window.location.replace(path);
  };

  return {
    isOpen:
      searchParams.get(QUERYPARAMS.IS_OPEN) === 'true' && searchParams.get('drawer') === drawerName,
    closeDrawer: () => setSearchParams({}),
    searchParams,
    setSearchParams,
    handleRedirectTo: (path: string) => toogleRedirectTo(path),
  };
};
